import { getStoreId } from "$/hooks/use-store-information.ts"
import alfredImpactQueries from "$/lib/queries/alfred-impact-queries.ts"
import { requireAdmin } from "$/lib/require-admin.ts"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/alfred-impact/")({
  loader: async ({ context: { queryClient } }) => {
    await requireAdmin(queryClient)
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(alfredImpactQueries.detail(storeId))
    }

    return {
      crumb: "alfred.pages.alfredImpact.crumbs.alfredImpact",
    }
  },
})
